import React from 'react';
import { Card, CardHeader, Row, Col, Container } from 'reactstrap';
import BranchTreatment from './BranchTreatment';
import TableCalendarGrid from './TableCalendarGrid';
import { H3 } from 'AbstractElements';
import { useSelector } from 'react-redux';
import 'moment/locale/id';

const groupSchedulesByDate = (schedules) => {
    const grouped = {};
    schedules.forEach((item) => {
        if (!grouped[item.schedule_date]) {
            grouped[item.schedule_date] = [];
        }
        grouped[item.schedule_date].push(item);
    });

    // Sort each group by id in ascending order
    Object.keys(grouped).forEach((date) => {
        grouped[date].sort((a, b) => a.id - b.id);
    });

    return grouped;
};

const ScheduleList = ({ schedules }) => { 
    const currentBranch = useSelector((state) => state.branch.currentBranch);
    const groupedSchedules = groupSchedulesByDate(schedules);


    return (
        <Container fluid={true}>
            <Row>
                <Col sm={{ size: 6, order: 1 }} md={{ size: 6, order: 1 }} lg={{ size: 6, order: 1 }} xl={{ size: 6, order: 1 }} xs={{ size: 12, order: 2 }}>
                    <Card>
                        <CardHeader className="pb-3 text-center">
                            <H3>Daftar Pengaturan Jadwal di {currentBranch?.name}</H3>
                        </CardHeader>
                        <Col sm="12" lg="12" xl="12">
                            <TableCalendarGrid groupedSchedules={groupedSchedules} />
                        </Col>
                    </Card>
                </Col>
                <BranchTreatment />
            </Row>
        </Container>
        
    );
};

export default ScheduleList;
